"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LINE_CHART_DEFAULT_COLOR = void 0;
exports.LINE_CHART_DEFAULT_COLOR = 'hsl(121, 70%, 50%)';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhcnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbnN0YW50cy9jaGFydHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7O0FBRVUsUUFBQSx3QkFBd0IsR0FBRyxvQkFBb0IsQ0FBQyJ9